<template>
  <b-form-group
    :label="title"
    :label-for="id"
    :description="description"
    label-cols-sm="3"
  >
    <b-form-textarea
      :id="id"
      :rows="rows"
      v-model="value"
      :placeholder="placeholder"
      :required="required"
      @input="changed"
    ></b-form-textarea>

    <slot>
    <!-- 他に表示する要素があればここに入る -->
    </slot>
  </b-form-group>
</template>

<script>
export default {
  name: 'ElementTextArea',
  props: {
    title: String,
    id: String,
    placeholder: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    vModel: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 2
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      value: this.vModel
    }
  },
  methods: {
    changed: function () {
      this.$emit('changed', { value: this.value, id: this.id })
    }
  },
  watch: {
    vModel() {
      this.value = this.vModel
    }
  }
}
</script>
